// NGRX
import { createFeatureSelector, createSelector } from '@ngrx/store';
// CRUD
import { QueryResultsModel, HttpExtenstionsModel } from '../../_base/crud';
// State
import { LinksState } from '../_reducers/link.reducers';
import { each } from 'lodash-es';
import { Link } from '../_models/link.model';

export const selectLinksState = createFeatureSelector<LinksState>('links');

export const selectLinkById = (linkId: number) =>
  createSelector(selectLinksState, (linksState) =>
    linksState.links.find((link) => link.id === linkId),
  );

export const selectLinksPageLoading = createSelector(selectLinksState, (linksState) => {
  return linksState.listLoading;
});

export const selectLinksShowInitWaitingMessage = createSelector(
  selectLinksState,
  (linksState) => linksState.showInitWaitingMessage,
);

export const selectLinkError = createSelector(selectLinksState, (linksState) => linksState.error);

export const selectLinkLatestSuccessfullAction = createSelector(
  selectLinksState,
  (linksState) => linksState.latestSuccessfullAction,
);

export const selectAllLinks = createSelector(selectLinksState, (linksState) => linksState.links);

export const selectLinksInStore = createSelector(selectLinksState, (linksState) => {
  const items: Link[] = [];
  each(linksState.entities, (element) => {
    items.push(element);
  });
  const httpExtension = new HttpExtenstionsModel();
  const result: Link[] = httpExtension.sortArray(
    items,
    linksState.lastQuery.sortField,
    linksState.lastQuery.sortOrder,
  );
  return new QueryResultsModel(result, linksState.totalCount);
});

export const selectHasLinksInStore = createSelector(selectLinksState, (queryResult) => {
  if (!queryResult.totalCount) {
    return false;
  }

  return true;
});
